import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { AlertMessage } from "../../constants/messages/alert-message";
import { GetAppConstResponse } from "../../data/models/get-app-const-response";
import { SessionInfoSingleton } from "../../data/singleton/session-info.singleton";
import { AuthService } from "../../services/auth/auth.service";
import { Observable } from "rxjs";

/**
 * CommonAPIのパス「/getrakusugiappconstants」以下のAPIに関するクラス
 */
@Injectable({
  providedIn: "root",
})
export class GetAppConstantsApi {
  /**
   * コンストラクタ
   */
  constructor(
    private sessionInfoSingleton: SessionInfoSingleton,
    private httpClient: HttpClient
  ) {}

  /** GET */
  /**
   * S3の定数JSONを取得する
   * - APIパス：/getrakusugiappconstants
   * @returns Observable<Object>型のレスポンス
   */
  getAppConstants(): Observable<Object> {
    var url = "";
    switch (environment.apiEnv) {
      case "dev":
        url = `https://common-api.dev.rakusugikenshin.com/getrakusugiappconstants?env=`;
        break;
      case "stg":
        url = `https://common-api.stg.rakusugikenshin.com/getrakusugiappconstants?env=`;
        break;
      case "prd":
        url = `https://common-api.rakusugikenshin.com/getrakusugiappconstants?env=`;
        break;
    }
    url = url + environment.apiEnv;

    return this.httpClient
      .get(url, {
        headers: new HttpHeaders({
          Authorization: this.sessionInfoSingleton.getIdToken(),
          "Content-Type": "application/json",
        }),
      })
  }
}
